const IconsArray = [
  { name: "address-book", unicode: "f2b9", fontFamily: "far" }, // regular
  { name: "address-card", unicode: "f2bb", fontFamily: "far" },
  { name: "adjust", unicode: "f042", fontFamily: "fas" },
  { name: "air-freshener", unicode: "f5d0", fontFamily: "fas" },
  { name: "align-center", unicode: "f037", fontFamily: "fas" },
  { name: "align-justify", unicode: "f039", fontFamily: "fas" },
  { name: "align-left", unicode: "f036", fontFamily: "fas" },
  { name: "align-right", unicode: "f038", fontFamily: "fas" },
  { name: "allergies", unicode: "f461", fontFamily: "fas" },
  { name: "ambulance", unicode: "f0f9", fontFamily: "fas" },
  { name: "american-sign-language-interpreting", unicode: "f2a3", fontFamily: "fas" },
  { name: "anchor", unicode: "f13d", fontFamily: "fas" },
  { name: "angle-double-down", unicode: "f103", fontFamily: "fas" },
  { name: "angle-double-left", unicode: "f100", fontFamily: "fas" },
  { name: "angle-double-right", unicode: "f101", fontFamily: "fas" },
  { name: "angle-double-up", unicode: "f102", fontFamily: "fas" },
  { name: "angle-down", unicode: "f107", fontFamily: "fas" },
  { name: "angle-left", unicode: "f104", fontFamily: "fas" },
  { name: "angle-right", unicode: "f105", fontFamily: "fas" },
  { name: "angle-up", unicode: "f106", fontFamily: "fas" },
  { name: "angry", unicode: "f556", fontFamily: "far" },
  { name: "ankh", unicode: "f644", fontFamily: "fas" },
  { name: "apple-alt", unicode: "f5d1", fontFamily: "fas" },
  { name: "archive", unicode: "f187", fontFamily: "fas" },
  { name: "archway", unicode: "f557", fontFamily: "fas" },
  { name: "arrow-alt-circle-down", unicode: "f358", fontFamily: "far" },
  { name: "arrow-alt-circle-left", unicode: "f359", fontFamily: "far" },
  { name: "arrow-alt-circle-right", unicode: "f35a", fontFamily: "far" },
  { name: "arrow-alt-circle-up", unicode: "f35b", fontFamily: "far" },
  { name: "arrow-circle-down", unicode: "f0ab", fontFamily: "fas" },
  { name: "arrow-circle-left", unicode: "f0a8", fontFamily: "fas" },
  { name: "arrow-circle-right", unicode: "f0a9", fontFamily: "fas" },
  { name: "arrow-circle-up", unicode: "f0aa", fontFamily: "fas" },
  { name: "arrow-down", unicode: "f063", fontFamily: "fas" },
  { name: "arrow-left", unicode: "f060", fontFamily: "fas" },
  { name: "arrow-right", unicode: "f061", fontFamily: "fas" },
  { name: "arrow-up", unicode: "f062", fontFamily: "fas" },
  { name: "arrows-alt", unicode: "f0b2", fontFamily: "fas" },
  { name: "assistive-listening-systems", unicode: "f2a2", fontFamily: "fas" },
  { name: "asterisk", unicode: "f069", fontFamily: "fas" },
  { name: "at", unicode: "f1fa", fontFamily: "fas" },
  { name: "atlas", unicode: "f558", fontFamily: "fas" },
  { name: "atom", unicode: "f5d2", fontFamily: "fas" },
  { name: "award", unicode: "f559", fontFamily: "fas" },
  { name: "backspace", unicode: "f55a", fontFamily: "fas" },
  { name: "backward", unicode: "f04a", fontFamily: "fas" },
  { name: "balance-scale", unicode: "f24e", fontFamily: "fas" },
  { name: "ban", unicode: "f05e", fontFamily: "fas" },
  { name: "band-aid", unicode: "f462", fontFamily: "fas" },
  { name: "barcode", unicode: "f02a", fontFamily: "fas" },
  { name: "bars", unicode: "f0c9", fontFamily: "fas" },
  { name: "basketball-ball", unicode: "f434", fontFamily: "fas" },
  { name: "bath", unicode: "f2cd", fontFamily: "fas" },
  { name: "battery-full", unicode: "f240", fontFamily: "fas" },
  { name: "bed", unicode: "f236", fontFamily: "fas" },
  { name: "beer", unicode: "f0fc", fontFamily: "fas" },
  { name: "bell", unicode: "f0f3", fontFamily: "far" },
  { name: "bell-slash", unicode: "f1f6", fontFamily: "far" },
  { name: "bicycle", unicode: "f206", fontFamily: "fas" },
  { name: "binoculars", unicode: "f1e5", fontFamily: "fas" },
  { name: "birthday-cake", unicode: "f1fd", fontFamily: "fas" },
  { name: "bold", unicode: "f032", fontFamily: "fas" },
  { name: "bolt", unicode: "f0e7", fontFamily: "fas" },
  { name: "bomb", unicode: "f1e2", fontFamily: "fas" },
  { name: "book", unicode: "f02d", fontFamily: "fas" },
  { name: "bookmark", unicode: "f02e", fontFamily: "far" },
  { name: "briefcase", unicode: "f0b1", fontFamily: "fas" },
  { name: "bug", unicode: "f188", fontFamily: "fas" },
  { name: "building", unicode: "f1ad", fontFamily: "far" },
  { name: "bullhorn", unicode: "f0a1", fontFamily: "fas" },
  { name: "bus", unicode: "f207", fontFamily: "fas" },
  { name: "calculator", unicode: "f1ec", fontFamily: "fas" },
  { name: "calendar", unicode: "f133", fontFamily: "far" },
  { name: "camera", unicode: "f030", fontFamily: "fas" },
  { name: "car", unicode: "f1b9", fontFamily: "fas" }
];

export { IconsArray };
